var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('prd-loader'):_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"col":"","lg":"12"}},[_c('create-or-edit-subscription',{attrs:{"subscription":_vm.subscription}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }